import { RoleType } from "./role-types";

export class RoleTypesHierarchy {
    public static RoleTypesHierarchy =
        [
            { value: 1, name: "Trial" },
            { value: 2, name: "Premium" },
            { value: 3, name: "Administrator" },
        ]
}